import script from "./HomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=8305ebe4&lang=less&scoped=true"

import exportComponent from "/Users/wangwangao/Desktop/project/浦东-外接/vue3-TS-vant-env/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8305ebe4"]])

export default __exports__